import { MediaPartnersFilter } from '../models/impact-partners.model';
import { DropDownConfig } from '../models/multiselect-dropdown.model';

export const COUNTRY_CODE_DROPDOWN_CONFIG: DropDownConfig = {
  allowSearchFilter: true,
  title: 'Country Code',
  placeholder: 'Select',
  searchPlaceholderText: '',
  allowPagination: true,
  required: true,
};

export const MEDIA_PARTNERS_DEFAULT_FILTER: MediaPartnersFilter = {
  searchText: '',
  pageNumber: 1,
  limit: 10,
  phone: '',
  mediaId: '',
};
export const COUNTRY_CODE = [
  {
    value: '7840',
    label: '+7840',
    displayLabel: 'Abkhazia (+7840)',
  },
  {
    value: '7940',
    label: '+7940',
    displayLabel: 'Abkhazia_ (+7940)',
  },
  {
    value: '93',
    label: '+93',
    displayLabel: 'Afghanistan (+93)',
  },
  {
    value: '355',
    label: '+355',
    displayLabel: 'Albania (+355)',
  },
  {
    value: '213',
    label: '+213',
    displayLabel: 'Algeria (+213)',
  },
  {
    value: '1684',
    label: '+1684',
    displayLabel: 'American Samoa (+1684)',
  },
  {
    value: '376',
    label: '+376',
    displayLabel: 'Andorra (+376)',
  },
  {
    value: '244',
    label: '+244',
    displayLabel: 'Angola (+244)',
  },
  {
    value: '1264',
    label: '+1264',
    displayLabel: 'Anguilla (+1264)',
  },
  {
    value: '1268',
    label: '+1268',
    displayLabel: 'Antigua and Barbuda (+1268)',
  },
  {
    value: '54',
    label: '+54',
    displayLabel: 'Argentina (+54)',
  },
  {
    value: '374',
    label: '+374',
    displayLabel: 'Armenia (+374)',
  },
  {
    value: '297',
    label: '+297',
    displayLabel: 'Aruba (+297)',
  },
  {
    value: '247',
    label: '+247',
    displayLabel: 'Ascension (+247)',
  },
  {
    value: '61',
    label: '+61',
    displayLabel: 'Australia (+61)',
  },
  {
    value: '672',
    label: '+672',
    displayLabel: 'Australian External Territories (+672)',
  },
  {
    value: '43',
    label: '+43',
    displayLabel: 'Austria (+43)',
  },
  {
    value: '994',
    label: '+994',
    displayLabel: 'Azerbaijan (+994)',
  },
  {
    value: '1242',
    label: '+1242',
    displayLabel: 'Bahamas (+1242)',
  },
  {
    value: '973',
    label: '+973',
    displayLabel: 'Bahrain (+973)',
  },
  {
    value: '880',
    label: '+880',
    displayLabel: 'Bangladesh (+880)',
  },
  {
    value: '1246',
    label: '+1246',
    displayLabel: 'Barbados (+1246)',
  },
  {
    value: '1268',
    label: '+1268',
    displayLabel: 'Barbuda (+1268)',
  },
  {
    value: '375',
    label: '+375',
    displayLabel: 'Belarus (+375)',
  },
  {
    value: '32',
    label: '+32',
    displayLabel: 'Belgium (+32)',
  },
  {
    value: '501',
    label: '+501',
    displayLabel: 'Belize (+501)',
  },
  {
    value: '229',
    label: '+229',
    displayLabel: 'Benin (+229)',
  },
  {
    value: '1441',
    label: '+1441',
    displayLabel: 'Bermuda (+1441)',
  },
  {
    value: '975',
    label: '+975',
    displayLabel: 'Bhutan (+975)',
  },
  {
    value: '591',
    label: '+591',
    displayLabel: 'Bolivia (+591)',
  },
  {
    value: '387',
    label: '+387',
    displayLabel: 'Bosnia and Herzegovina (+387)',
  },
  {
    value: '267',
    label: '+267',
    displayLabel: 'Botswana (+267)',
  },
  {
    value: '55',
    label: '+55',
    displayLabel: 'Brazil (+55)',
  },
  {
    value: '246',
    label: '+246',
    displayLabel: 'British Indian Ocean Territory (+246)',
  },
  {
    value: '1284',
    label: '+1284',
    displayLabel: 'British Virgin Islands (+1284)',
  },
  {
    value: '673',
    label: '+673',
    displayLabel: 'Brunei (+673)',
  },
  {
    value: '359',
    label: '+359',
    displayLabel: 'Bulgaria (+359)',
  },
  {
    value: '226',
    label: '+226',
    displayLabel: 'Burkina Faso (+226)',
  },
  {
    value: '257',
    label: '+257',
    displayLabel: 'Burundi (+257)',
  },
  {
    value: '855',
    label: '+855',
    displayLabel: 'Cambodia (+855)',
  },
  {
    value: '237',
    label: '+237',
    displayLabel: 'Cameroon (+237)',
  },
  {
    value: '1',
    label: '+1',
    displayLabel: 'Canada (+1)',
  },
  {
    value: '238',
    label: '+238',
    displayLabel: 'Cape Verde (+238)',
  },
  {
    value: '345',
    label: '+345',
    displayLabel: 'Cayman Islands (+345)',
  },
  {
    value: '236',
    label: '+236',
    displayLabel: 'Central African Republic (+236)',
  },
  {
    value: '235',
    label: '+235',
    displayLabel: 'Chad (+235)',
  },
  {
    value: '56',
    label: '+56',
    displayLabel: 'Chile (+56)',
  },
  {
    value: '86',
    label: '+86',
    displayLabel: 'China (+86)',
  },
  {
    value: '61',
    label: '+61',
    displayLabel: 'Christmas Island (+61)',
  },
  {
    value: '61',
    label: '+61',
    displayLabel: 'Cocos-Keeling Islands (+61)',
  },
  {
    value: '57',
    label: '+57',
    displayLabel: 'Colombia (+57)',
  },
  {
    value: '269',
    label: '+269',
    displayLabel: 'Comoros (+269)',
  },
  {
    value: '242',
    label: '+242',
    displayLabel: 'Congo (+242)',
  },
  {
    value: '243',
    label: '+243',
    displayLabel: 'Congo, Dem. Rep. of (Zaire) (+243)',
  },
  {
    value: '682',
    label: '+682',
    displayLabel: 'Cook Islands (+682)',
  },
  {
    value: '506',
    label: '+506',
    displayLabel: 'Costa Rica (+506)',
  },
  {
    value: '385',
    label: '+385',
    displayLabel: 'Croatia (+385)',
  },
  {
    value: '53',
    label: '+53',
    displayLabel: 'Cuba (+53)',
  },
  {
    value: '599',
    label: '+599',
    displayLabel: 'Curacao (+599)',
  },
  {
    value: '537',
    label: '+537',
    displayLabel: 'Cyprus (+537)',
  },
  {
    value: '420',
    label: '+420',
    displayLabel: 'Czech Republic (+420)',
  },
  {
    value: '45',
    label: '+45',
    displayLabel: 'Denmark (+45)',
  },
  {
    value: '246',
    label: '+246',
    displayLabel: 'Diego Garcia (+246)',
  },
  {
    value: '253',
    label: '+253',
    displayLabel: 'Djibouti (+253)',
  },
  {
    value: '1767',
    label: '+1767',
    displayLabel: 'Dominica (+1767)',
  },
  {
    value: '1809',
    label: '+1809',
    displayLabel: 'Dominican Republic (+1809)',
  },
  {
    value: '1829',
    label: '+1829',
    displayLabel: 'Dominican Republic_ (+1829)',
  },
  {
    value: '1849',
    label: '+1849',
    displayLabel: 'Dominican Republic__ (+1849)',
  },
  {
    value: '670',
    label: '+670',
    displayLabel: 'East Timor (+670)',
  },
  {
    value: '56',
    label: '+56',
    displayLabel: 'Easter Island (+56)',
  },
  {
    value: '593',
    label: '+593',
    displayLabel: 'Ecuador (+593)',
  },
  {
    value: '20',
    label: '+20',
    displayLabel: 'Egypt (+20)',
  },
  {
    value: '503',
    label: '+503',
    displayLabel: 'El Salvador (+503)',
  },
  {
    value: '240',
    label: '+240',
    displayLabel: 'Equatorial Guinea (+240)',
  },
  {
    value: '291',
    label: '+291',
    displayLabel: 'Eritrea (+291)',
  },
  {
    value: '372',
    label: '+372',
    displayLabel: 'Estonia (+372)',
  },
  {
    value: '251',
    label: '+251',
    displayLabel: 'Ethiopia (+251)',
  },
  {
    value: '500',
    label: '+500',
    displayLabel: 'Falkland Islands (+500)',
  },
  {
    value: '298',
    label: '+298',
    displayLabel: 'Faroe Islands (+298)',
  },
  {
    value: '679',
    label: '+679',
    displayLabel: 'Fiji (+679)',
  },
  {
    value: '358',
    label: '+358',
    displayLabel: 'Finland (+358)',
  },
  {
    value: '33',
    label: '+33',
    displayLabel: 'France (+33)',
  },
  {
    value: '596',
    label: '+596',
    displayLabel: 'French Antilles (+596)',
  },
  {
    value: '594',
    label: '+594',
    displayLabel: 'French Guiana (+594)',
  },
  {
    value: '689',
    label: '+689',
    displayLabel: 'French Polynesia (+689)',
  },
  {
    value: '241',
    label: '+241',
    displayLabel: 'Gabon (+241)',
  },
  {
    value: '220',
    label: '+220',
    displayLabel: 'Gambia (+220)',
  },
  {
    value: '995',
    label: '+995',
    displayLabel: 'Georgia (+995)',
  },
  {
    value: '49',
    label: '+49',
    displayLabel: 'Germany (+49)',
  },
  {
    value: '233',
    label: '+233',
    displayLabel: 'Ghana (+233)',
  },
  {
    value: '350',
    label: '+350',
    displayLabel: 'Gibraltar (+350)',
  },
  {
    value: '30',
    label: '+30',
    displayLabel: 'Greece (+30)',
  },
  {
    value: '299',
    label: '+299',
    displayLabel: 'Greenland (+299)',
  },
  {
    value: '1473',
    label: '+1473',
    displayLabel: 'Grenada (+1473)',
  },
  {
    value: '590',
    label: '+590',
    displayLabel: 'Guadeloupe (+590)',
  },
  {
    value: '1671',
    label: '+1671',
    displayLabel: 'Guam (+1671)',
  },
  {
    value: '502',
    label: '+502',
    displayLabel: 'Guatemala (+502)',
  },
  {
    value: '224',
    label: '+224',
    displayLabel: 'Guinea (+224)',
  },
  {
    value: '245',
    label: '+245',
    displayLabel: 'Guinea-Bissau (+245)',
  },
  {
    value: '595',
    label: '+595',
    displayLabel: 'Guyana (+595)',
  },
  {
    value: '509',
    label: '+509',
    displayLabel: 'Haiti (+509)',
  },
  {
    value: '504',
    label: '+504',
    displayLabel: 'Honduras (+504)',
  },
  {
    value: '852',
    label: '+852',
    displayLabel: 'Hong Kong SAR China (+852)',
  },
  {
    value: '36',
    label: '+36',
    displayLabel: 'Hungary (+36)',
  },
  {
    value: '354',
    label: '+354',
    displayLabel: 'Iceland (+354)',
  },
  {
    value: '91',
    label: '+91',
    displayLabel: 'India (+91)',
  },
  {
    value: '62',
    label: '+62',
    displayLabel: 'Indonesia (+62)',
  },
  {
    value: '98',
    label: '+98',
    displayLabel: 'Iran (+98)',
  },
  {
    value: '964',
    label: '+964',
    displayLabel: 'Iraq (+964)',
  },
  {
    value: '353',
    label: '+353',
    displayLabel: 'Ireland (+353)',
  },
  {
    value: '972',
    label: '+972',
    displayLabel: 'Israel (+972)',
  },
  {
    value: '39',
    label: '+39',
    displayLabel: 'Italy (+39)',
  },
  {
    value: '225',
    label: '+225',
    displayLabel: 'Ivory Coast (+225)',
  },
  {
    value: '1876',
    label: '+1876',
    displayLabel: 'Jamaica (+1876)',
  },
  {
    value: '81',
    label: '+81',
    displayLabel: 'Japan (+81)',
  },
  {
    value: '962',
    label: '+962',
    displayLabel: 'Jordan (+962)',
  },
  {
    value: '77',
    label: '+77',
    displayLabel: 'Kazakhstan (+77)',
  },
  {
    value: '254',
    label: '+254',
    displayLabel: 'Kenya (+254)',
  },
  {
    value: '686',
    label: '+686',
    displayLabel: 'Kiribati (+686)',
  },
  {
    value: '965',
    label: '+965',
    displayLabel: 'Kuwait (+965)',
  },
  {
    value: '996',
    label: '+996',
    displayLabel: 'Kyrgyzstan (+996)',
  },
  {
    value: '856',
    label: '+856',
    displayLabel: 'Laos (+856)',
  },
  {
    value: '371',
    label: '+371',
    displayLabel: 'Latvia (+371)',
  },
  {
    value: '961',
    label: '+961',
    displayLabel: 'Lebanon (+961)',
  },
  {
    value: '266',
    label: '+266',
    displayLabel: 'Lesotho (+266)',
  },
  {
    value: '231',
    label: '+231',
    displayLabel: 'Liberia (+231)',
  },
  {
    value: '218',
    label: '+218',
    displayLabel: 'Libya (+218)',
  },
  {
    value: '423',
    label: '+423',
    displayLabel: 'Liechtenstein (+423)',
  },
  {
    value: '370',
    label: '+370',
    displayLabel: 'Lithuania (+370)',
  },
  {
    value: '352',
    label: '+352',
    displayLabel: 'Luxembourg (+352)',
  },
  {
    value: '853',
    label: '+853',
    displayLabel: 'Macau SAR China (+853)',
  },
  {
    value: '389',
    label: '+389',
    displayLabel: 'Macedonia (+389)',
  },
  {
    value: '261',
    label: '+261',
    displayLabel: 'Madagascar (+261)',
  },
  {
    value: '265',
    label: '+265',
    displayLabel: 'Malawi (+265)',
  },
  {
    value: '60',
    label: '+60',
    displayLabel: 'Malaysia (+60)',
  },
  {
    value: '960',
    label: '+960',
    displayLabel: 'Maldives (+960)',
  },
  {
    value: '223',
    label: '+223',
    displayLabel: 'Mali (+223)',
  },
  {
    value: '356',
    label: '+356',
    displayLabel: 'Malta (+356)',
  },
  {
    value: '692',
    label: '+692',
    displayLabel: 'Marshall Islands (+692)',
  },
  {
    value: '596',
    label: '+596',
    displayLabel: 'Martinique (+596)',
  },
  {
    value: '222',
    label: '+222',
    displayLabel: 'Mauritania (+222)',
  },
  {
    value: '230',
    label: '+230',
    displayLabel: 'Mauritius (+230)',
  },
  {
    value: '262',
    label: '+262',
    displayLabel: 'Mayotte (+262)',
  },
  {
    value: '52',
    label: '+52',
    displayLabel: 'Mexico (+52)',
  },
  {
    value: '691',
    label: '+691',
    displayLabel: 'Micronesia (+691)',
  },
  {
    value: '1808',
    label: '+1808',
    displayLabel: 'Midway Island (+1808)',
  },
  {
    value: '373',
    label: '+373',
    displayLabel: 'Moldova (+373)',
  },
  {
    value: '377',
    label: '+377',
    displayLabel: 'Monaco (+377)',
  },
  {
    value: '976',
    label: '+976',
    displayLabel: 'Mongolia (+976)',
  },
  {
    value: '382',
    label: '+382',
    displayLabel: 'Montenegro (+382)',
  },
  {
    value: '1664',
    label: '+1664',
    displayLabel: 'Montserrat (+1664)',
  },
  {
    value: '212',
    label: '+212',
    displayLabel: 'Morocco (+212)',
  },
  {
    value: '95',
    label: '+95',
    displayLabel: 'Myanmar (+95)',
  },
  {
    value: '264',
    label: '+264',
    displayLabel: 'Namibia (+264)',
  },
  {
    value: '674',
    label: '+674',
    displayLabel: 'Nauru (+674)',
  },
  {
    value: '977',
    label: '+977',
    displayLabel: 'Nepal (+977)',
  },
  {
    value: '31',
    label: '+31',
    displayLabel: 'Netherlands (+31)',
  },
  {
    value: '599',
    label: '+599',
    displayLabel: 'Netherlands Antilles (+599)',
  },
  {
    value: '1869',
    label: '+1869',
    displayLabel: 'Nevis (+1869)',
  },
  {
    value: '687',
    label: '+687',
    displayLabel: 'New Caledonia (+687)',
  },
  {
    value: '64',
    label: '+64',
    displayLabel: 'New Zealand (+64)',
  },
  {
    value: '505',
    label: '+505',
    displayLabel: 'Nicaragua (+505)',
  },
  {
    value: '227',
    label: '+227',
    displayLabel: 'Niger (+227)',
  },
  {
    value: '234',
    label: '+234',
    displayLabel: 'Nigeria (+234)',
  },
  {
    value: '683',
    label: '+683',
    displayLabel: 'Niue (+683)',
  },
  {
    value: '672',
    label: '+672',
    displayLabel: 'Norfolk Island (+672)',
  },
  {
    value: '850',
    label: '+850',
    displayLabel: 'North Korea (+850)',
  },
  {
    value: '1670',
    label: '+1670',
    displayLabel: 'Northern Mariana Islands (+1670)',
  },
  {
    value: '47',
    label: '+47',
    displayLabel: 'Norway (+47)',
  },
  {
    value: '968',
    label: '+968',
    displayLabel: 'Oman (+968)',
  },
  {
    value: '92',
    label: '+92',
    displayLabel: 'Pakistan (+92)',
  },
  {
    value: '680',
    label: '+680',
    displayLabel: 'Palau (+680)',
  },
  {
    value: '970',
    label: '+970',
    displayLabel: 'Palestinian Territory (+970)',
  },
  {
    value: '507',
    label: '+507',
    displayLabel: 'Panama (+507)',
  },
  {
    value: '675',
    label: '+675',
    displayLabel: 'Papua New Guinea (+675)',
  },
  {
    value: '595',
    label: '+595',
    displayLabel: 'Paraguay (+595)',
  },
  {
    value: '51',
    label: '+51',
    displayLabel: 'Peru (+51)',
  },
  {
    value: '63',
    label: '+63',
    displayLabel: 'Philippines (+63)',
  },
  {
    value: '48',
    label: '+48',
    displayLabel: 'Poland (+48)',
  },
  {
    value: '351',
    label: '+351',
    displayLabel: 'Portugal (+351)',
  },
  {
    value: '1787',
    label: '+1787',
    displayLabel: 'Puerto Rico (+1787)',
  },
  {
    value: '1939',
    label: '+1939',
    displayLabel: 'Puerto Rico_ (+1939)',
  },
  {
    value: '974',
    label: '+974',
    displayLabel: 'Qatar (+974)',
  },
  {
    value: '262',
    label: '+262',
    displayLabel: 'Reunion (+262)',
  },
  {
    value: '40',
    label: '+40',
    displayLabel: 'Romania (+40)',
  },
  {
    value: '7',
    label: '+7',
    displayLabel: 'Russia (+7)',
  },
  {
    value: '250',
    label: '+250',
    displayLabel: 'Rwanda (+250)',
  },
  {
    value: '685',
    label: '+685',
    displayLabel: 'Samoa (+685)',
  },
  {
    value: '378',
    label: '+378',
    displayLabel: 'San Marino (+378)',
  },
  {
    value: '966',
    label: '+966',
    displayLabel: 'Saudi Arabia (+966)',
  },
  {
    value: '221',
    label: '+221',
    displayLabel: 'Senegal (+221)',
  },
  {
    value: '381',
    label: '+381',
    displayLabel: 'Serbia (+381)',
  },
  {
    value: '248',
    label: '+248',
    displayLabel: 'Seychelles (+248)',
  },
  {
    value: '232',
    label: '+232',
    displayLabel: 'Sierra Leone (+232)',
  },
  {
    value: '65',
    label: '+65',
    displayLabel: 'Singapore (+65)',
  },
  {
    value: '421',
    label: '+421',
    displayLabel: 'Slovakia (+421)',
  },
  {
    value: '386',
    label: '+386',
    displayLabel: 'Slovenia (+386)',
  },
  {
    value: '677',
    label: '+677',
    displayLabel: 'Solomon Islands (+677)',
  },
  {
    value: '27',
    label: '+27',
    displayLabel: 'South Africa (+27)',
  },
  {
    value: '500',
    label: '+500',
    displayLabel: 'South Georgia and the South Sandwich Islands (+500)',
  },
  {
    value: '82',
    label: '+82',
    displayLabel: 'South Korea (+82)',
  },
  {
    value: '34',
    label: '+34',
    displayLabel: 'Spain (+34)',
  },
  {
    value: '94',
    label: '+94',
    displayLabel: 'Sri Lanka (+94)',
  },
  {
    value: '249',
    label: '+249',
    displayLabel: 'Sudan (+249)',
  },
  {
    value: '597',
    label: '+597',
    displayLabel: 'Suriname (+597)',
  },
  {
    value: '268',
    label: '+268',
    displayLabel: 'Swaziland (+268)',
  },
  {
    value: '46',
    label: '+46',
    displayLabel: 'Sweden (+46)',
  },
  {
    value: '41',
    label: '+41',
    displayLabel: 'Switzerland (+41)',
  },
  {
    value: '963',
    label: '+963',
    displayLabel: 'Syria (+963)',
  },
  {
    value: '886',
    label: '+886',
    displayLabel: 'Taiwan (+886)',
  },
  {
    value: '992',
    label: '+992',
    displayLabel: 'Tajikistan (+992)',
  },
  {
    value: '255',
    label: '+255',
    displayLabel: 'Tanzania (+255)',
  },
  {
    value: '66',
    label: '+66',
    displayLabel: 'Thailand (+66)',
  },
  {
    value: '670',
    label: '+670',
    displayLabel: 'Timor Leste (+670)',
  },
  {
    value: '228',
    label: '+228',
    displayLabel: 'Togo (+228)',
  },
  {
    value: '690',
    label: '+690',
    displayLabel: 'Tokelau (+690)',
  },
  {
    value: '676',
    label: '+676',
    displayLabel: 'Tonga (+676)',
  },
  {
    value: '1868',
    label: '+1868',
    displayLabel: 'Trinidad and Tobago (+1868)',
  },
  {
    value: '216',
    label: '+216',
    displayLabel: 'Tunisia (+216)',
  },
  {
    value: '90',
    label: '+90',
    displayLabel: 'Turkey (+90)',
  },
  {
    value: '993',
    label: '+993',
    displayLabel: 'Turkmenistan (+993)',
  },
  {
    value: '1649',
    label: '+1649',
    displayLabel: 'Turks and Caicos Islands (+1649)',
  },
  {
    value: '688',
    label: '+688',
    displayLabel: 'Tuvalu (+688)',
  },
  {
    value: '1340',
    label: '+1340',
    displayLabel: 'U.S. Virgin Islands (+1340)',
  },
  {
    value: '256',
    label: '+256',
    displayLabel: 'Uganda (+256)',
  },
  {
    value: '380',
    label: '+380',
    displayLabel: 'Ukraine (+380)',
  },
  {
    value: '971',
    label: '+971',
    displayLabel: 'United Arab Emirates (+971)',
  },
  {
    value: '44',
    label: '+44',
    displayLabel: 'United Kingdom (+44)',
  },
  {
    value: '1',
    label: '+1',
    displayLabel: 'United States (+1)',
  },
  {
    value: '598',
    label: '+598',
    displayLabel: 'Uruguay (+598)',
  },
  {
    value: '998',
    label: '+998',
    displayLabel: 'Uzbekistan (+998)',
  },
  {
    value: '678',
    label: '+678',
    displayLabel: 'Vanuatu (+678)',
  },
  {
    value: '58',
    label: '+58',
    displayLabel: 'Venezuela (+58)',
  },
  {
    value: '84',
    label: '+84',
    displayLabel: 'Vietnam (+84)',
  },
  {
    value: '1808',
    label: '+1808',
    displayLabel: 'Wake Island (+1808)',
  },
  {
    value: '681',
    label: '+681',
    displayLabel: 'Wallis and Futuna (+681)',
  },
  {
    value: '967',
    label: '+967',
    displayLabel: 'Yemen (+967)',
  },
  {
    value: '260',
    label: '+260',
    displayLabel: 'Zambia (+260)',
  },
  {
    value: '255',
    label: '+255',
    displayLabel: 'Zanzibar (+255)',
  },
  {
    value: '263',
    label: '+263',
    displayLabel: 'Zimbabwe (+263)',
  },
];
